"use strict";

// ### Global variables
window.isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
window.environment = {
  production: true,
  istest: false
};
window.environment.production = (document.location.host === 'www.express-sushi.com' || document.location.host === 'express-sushi.com' || document.location.host === 'www.express-sushi-omsk.ru' || document.location.host === 'express-sushi-omsk.ru');
window.environment.istest = ($.cookie('test') == 'true');
if (!environment.production || !!environment.istest) { console.warn('Is it test enviroment!');}
window.isEmpty = function (obj) {
  for (var key in obj) {
    return false; // /*/ если цикл хоть раз сработал, то объект не пустой => false */
  };
  return true; // /*/ дошли до этой строки - значит цикл не нашёл ни одного свойства => true */
};
window.isSafari = false;
var userAgent = navigator.userAgent.toLowerCase();
if (userAgent.indexOf('safari') != -1) {
  if (userAgent.indexOf('chrome') > -1) {
    window.isSafari = false;
  } else {
    window.isSafari = true;
  }
};
window.supportsLazyLoad = ('loading' in document.createElement('img'));

if(navigator.userAgent.match(/Trident\/7\./)) { // if IE
  $('body').on("mousewheel", function (event) {
    // remove default behavior
    event.preventDefault();

    //scroll without smoothing
    var wheelDelta = event.wheelDelta;
    var currentScrollPosition = window.pageYOffset;
    window.scrollTo(0, currentScrollPosition - wheelDelta);
  });
};

if (!Array.prototype.findIndex) {
  Array.prototype.findIndex = function(predicate) {
    if (this == null) {
      throw new TypeError('Array.prototype.findIndex called on null or undefined');
    }
    if (typeof predicate !== 'function') {
      throw new TypeError('predicate must be a function');
    }
    var list = Object(this);
    var length = list.length >>> 0;
    var thisArg = arguments[1];
    var value;

    for (var i = 0; i < length; i++) {
      value = list[i];
      if (predicate.call(thisArg, value, i, list)) {
        return i;
      }
    }
    return -1;
  };
}

$.fn.serializeObject = function() {
  var o = {};
  var a = this.serializeArray();
  $.each(a, function() {
    if (o[this.name]) {
      if (!o[this.name].push) {
        o[this.name] = [o[this.name]];
      }
      o[this.name].push(this.value || '');
    } else {
      o[this.name] = this.value || '';
    }
  });
  return o;
};

/* ### GLOBAL VAR */
var
  $xsScreen = 480, // mobile
  $smScreen = 768, // tablet vertical
  $mdScreen = 992, // tablet horizontal, notebook
  $lgScreen = 1200, // desktop

  mobileScreen = $xsScreen,
  tabletScreen = $smScreen,
  notebookScreen = $mdScreen,
  desktopScreen = $lgScreen,

  orderElmK = 1,

  $bootstrapColorVariables = [
    'primary',
    'secondary',
    'success',
    'danger',
    'warning',
    'info',
    // 'light',
    // 'dark',
  ],

  $packing = 0, // цена единицы упаковочного материала
  delivery = 0,
  total_spent = 0,
  total_goods = 0, // Количество товаров в корзине
  $total = { amount: 0, price: 0 },
  min_order_value = $('#min_order_value').val(),
  preorder_shop = 0,
  cart,
  cartCookie,
  $widget = $(".cart_wrap"),
  $cartlist = $(".cart_list_scroller ._items"),
  date = new Date(),
  currDate = date.getDate(),
  currHours = date.getHours(),
  currMinutes = date.getMinutes(),
  startWorkHours = (typeof $orderTime !== "undefined")? $orderTime[0][0] : 9,
  endWorkHours = (typeof $orderTime !== "undefined")? $orderTime[1][0] : 21,
  endWorkMinutes = (typeof $orderTime !== "undefined")? $orderTime[1][1] : 29,
  $nWD = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1, startWorkHours - 1, 59, 0, 0),
  $storagePrefix = '_essite';

  var $smartbanner = true;

window.cart = cart;
window.nwd = $nWD;

// Вплывающее окно в нерабочее время
if (currHours < startWorkHours || ( currHours >= endWorkHours && currMinutes >= endWorkMinutes) ) {
  $('.quick_order').remove();
  $('#send_order').before('<div class="text-center form-group"><div class="alert alert-danger">Заказы через сайт принимаются с '+ startWorkHours +':00 до '+ endWorkHours +':30</div></div>');
  $('.product__controls').remove();
  $('#send_order').remove();

  if($('#modalClose').length > 0) {
    var _expires = $nWD,
      _modalClose = $.cookie('modalClose') || false;

    if (!_modalClose){
      setTimeout(function(){
        $('#modalClose').modal('show');
      }, 3000);
    }

    $('#modalClose').on('click', '[data-dismiss="modal"]', function(){
      if (!_modalClose) {
        // Ставим куки до начала следующего рабочего дня
        $.cookie('modalClose', 1, { expires: _expires, path: '/' });
      }
    });
  }
}

if($('#modalMobileApp').length > 0 && window.innerWidth <= 767 && document.location.pathname !== '/cashback') {
  var _expiresMobileApp = new Date(date.getFullYear(), date.getMonth() + 1, date.getDate(), 0, 0, 0, 0),
    _modalMobileAppCookie = $.cookie('modalMobileApp') || false,
    _modalMobileApp = $('#modalMobileApp');

  if (!_modalMobileAppCookie){
    setTimeout(function(){
      _modalMobileApp.modal('show');
    }, 1000);
  }

  _modalMobileApp.on('click', '._close', function(event){
    // event.preventDefault();
    if (!_modalMobileAppCookie) {
      // Ставим куки на месяц
      $.cookie('modalMobileApp', 1, { expires: _expiresMobileApp, path: '/' });
      _modalMobileApp.modal('hide');
    }
  });

  _modalMobileApp.on('click', '[data-dismiss="modal"]', function(){
    if (!_modalMobileAppCookie) {
      // Ставим куки до конца сессии
      $.cookie('modalMobileApp', 1, { path: '/' });
      _modalMobileApp.modal('hide');
    }
  });

}

var
_log = function(message, data) {
  return (environment.production && !environment.istest) ? false : console.log(message, data);
},
declination = function (a5, b1, c2, s) {
  var words = [a5, b1, c2],
    index = s % 100;
  if (index >=11 && index <= 14) {
    index = 0;
  } else {
    index = (index %= 10) < 5 ? (index > 2 ? 2 : index): 0;
  };
  return(words[index]);
}, // => END declination

// Универсальная функция ajax
sendData = function(data, url, type, dataType = 'JSON', contentType = 'application/json') {
  return $.ajax({
    type: type,
    url: url,
    dataType: dataType,
    contentType: contentType,
    data: data
  });
},

callConfirm = (elm) => {
  if(elm.data('confirm') !== 'undefined') {
    return (confirm(elm.data('confirm'))) ? ((elm.data('method') !== 'undefined') ? callMethod(elm): true) : false;
  } else {
    return false;
  }
},

callMethod = (elm) => {
  if(elm.data('method') !== 'undefined') {
    var _type = elm.data('method'),
    _url = elm.attr('href');

    return $.ajax({
      global: false,
      url: _url,
      type: _type,
      async: false,
      complete: function(xhr) {
        console.log(xhr.getResponseHeader('Refresh'));
        if(xhr.getResponseHeader('Refresh') !== undefined) {
          document.location.href = xhr.getResponseHeader('Refresh').split('0;url=')[1];
        }
      }
    });
  } else {
    return false;
  }
},

/** Обработчик события отметки активного элемента при scrollspy */
scrollSubNav = () => {
  const $navMenu = $('.nav-menu');
  const $nav = $navMenu.find('.nav');
  const mobileBreakpoint = 767.98;

  if (!$nav.length) return;

  $(window).on('activate.bs.scrollspy', function() {
    // Проверяем мобильный режим и фиксированное позиционирование
    if (!window.matchMedia(`(max-width: ${mobileBreakpoint}px)`).matches) return;
    if (!$navMenu.hasClass('affix')) return;

    const $activeLink = $nav.find('.nav-link.active');
    if (!$activeLink.length) return;

    // Получаем DOM-элементы
    const nav = $nav[0];
    const activeLink = $activeLink[0];

    // Рассчитываем позиции
    const navRect = nav.getBoundingClientRect();
    const linkRect = activeLink.getBoundingClientRect();

    // Вычисляем необходимую прокрутку с учетом границ
    const scrollPosition = linkRect.left - navRect.left + nav.scrollLeft - 15;

    // Анимируем прокрутку
    $nav.stop().animate({
      scrollLeft: scrollPosition
    }, {
      duration: 400,
      easing: 'swing',
      queue: false
    });

    console.log({
      navRect: navRect,
      linkRect: linkRect,
      scrollPosition: scrollPosition,
      computedPosition: nav.scrollLeft
    });
  });

},

// Навигация по якорям
scrollCatalog = function (id, delay, type) {
  // _log('scrollCatalog/id', id);
  // _log('scrollCatalog/type', type);

  scroll(0,0);

  var
    idOffsetTop = ( $(id).hasClass('menu-item') )? Math.round( $(id).parents('.menu-item-wrapper').offset().top ) - 30 : Math.round( $(id).offset().top ),
    bodyOffsetTop = $('body').offset().top,
    paddingTop = ( window.innerWidth <= 767 )? 65 : 5,
    sectionMenuTitleHeight = ( $(id).find('.section__menu-title').length )? $(id).find('.section__menu-title').height() : 0,
    pointsIconHeight = ( $('.points-icon').length )? $('.points-icon').height() : 0,
    _headerHeight = ( $('.header').length )? $('.header').outerHeight(true) : 0,
    _navbarHeight = ( $('.navbar').length )? $('.navbar').outerHeight(true) : 0,
    _navbarMenuHeight = ( $('.nav-menu').length )? $('.nav-menu').innerHeight() - 16 : 0,
    _navbarCollapseHeight = ( ($('.navbar-collapse').length )) && ($('.navbar-collapse').hasClass('show'))? $('.navbar-collapse').outerHeight(true) : 0,
    carouselMainHeight = ( $('.carousel-main').length )? $('.carousel-main').height() : 0,
    selectShopWrapHeight = ( $('.select-shop_wrap').length )? $('.select-shop_wrap').height() : 0,
    smartbannerHeight = ( $('#smartbanner').length )? $('#smartbanner').height() : 0,
    $chScrollPositions = Math.round( idOffsetTop - paddingTop - pointsIconHeight + _headerHeight + _navbarMenuHeight - selectShopWrapHeight - sectionMenuTitleHeight );

  // _log('scrollCatalog/_headerHeight', _headerHeight);
  // _log('scrollCatalog/_navbarHeight', _navbarHeight);
  // _log('scrollCatalog/_navbarMenuHeight', _navbarMenuHeight);
  // _log('scrollCatalog/_navbarCollapseHeight', _navbarCollapseHeight);

  if (!delay) { delay = 300; };

  if(type === 'direct') {
    document.location.hash = '';
    if( $(id).length > 0 ) {
      document.location.hash = id;
    }
  }

  $('html').delay(delay)
    .animate({
      // scrollTop: $chScrollPositions
      scrollTop: Math.round( $(id).offset().top - (( window.innerWidth <= 767 ) ? (_navbarHeight - _navbarCollapseHeight + _navbarMenuHeight) : (_headerHeight + _navbarHeight + _navbarMenuHeight)) )
    }, 400, 'swing', function () {
      // scrollSubNav();
    });

  if( !$('.navbar .navbar-toggler').hasClass('collapsed') ){
    $('.navbar .navbar-toggler').addClass('collapsed');
    $('#navbar-collapse').collapse('hide');
  }



  return true;
},

statusAction = (function () {
  var actionItem = $('.l-order-item.__bonus_row'),
    bonusStatusInput = $('<input type="hidden" id="selected_bonus" name="selected_bonus" class="required" value="0">'),
    _expires = $nWD;

  function check(){
    if( $total.price < parseInt( actionItem.data('minorder') ) ){
      actionItem.slideUp();
      $.cookie( 'selected_bonus', '{}', { expires: _expires, path: '/' });

      if ($('#selected_bonus').length>0) {
        $('#selected_bonus').remove();
      }
      return false;
    }
    else if( ( $total.price >= parseInt( actionItem.data('minorder') ) ) && !disbonus ) {
      actionItem.slideDown();
      if ($('#selected_bonus').length==0) {
        $('.order-address').prepend( bonusStatusInput );
      };
      return true;
    }
  }

  function minorder(){
    actionItem.each(function(){
    var self = $(this);
    actions[self.data('id')] = { 'minimal_order': self.data('minorder') };
    });
  }

  return { check: check, minorder: minorder };
})(), // => END statusAction;

packingStatus = (function () {
  function check(){
    var
      $cart = ($.cookie('cart') === undefined) ? {} : $.cookie('cart'),
      packItemCount = 0;
      $packing = 0;

    while ($cart.length > 0) { $cart = JSON.parse($cart); };

    for ( var pos in $cart ) {
      var posId = $("#" + $cart[pos].id),
        pack = parseInt(posId.data('packing')),
        price = parseInt(posId.data('price')),
        cat = parseInt($cart[pos].cat),
        a = parseInt($cart[pos].a);

      if ( pack === 1 ) { packing = 30; };
      if ( cat === 6 ) { packItemCount++; }

      if ( cat === 6 && a > 0) {
        $packing = $packing + ( a * price );
      }
    };

    if ( packItemCount < $('[data-categoryid="6"]').length ) {
      add();
    }

    // console.log('packingStatus.check.packItemCount', packItemCount);
    // console.log('packingStatus.check.$packing', $packing);
    widgetCart.updateTotal( $total.price + $packing );

    if ( $packing > 0 ) {
      return true;
    } else {
      return false;
    }
  }

  function add(){
    var $cart = ($.cookie('cart') === undefined) ? {} : $.cookie('cart'),
      _expires = $nWD;
    while($cart.length > 0) { $cart = JSON.parse($cart); };

    $('[data-categoryid="6"]').each(function(){
      var $this = $(this),
        artikul_id = $this.data('artikul'),
        t = $("#" + artikul_id),
        dvalue = t.data('dvalue'),
        price = t.data('price'),
        item = {
          id: artikul_id,
          nid: t.data('nomid'),
          cat: t.data('categoryid'),
          sid: t.data('shopid'),
          p: price,
          pp: 1,
          ps: 1,
          s: 1,
          t: t.data('type'),
          a: parseInt( t.data('amount') ),
          d: parseInt( t.data('delivery') )
        };

      // $cart[artikul_id] = item;
      $cart[t.data('nomid')] = item;
    });

    $.cookie('cart', JSON.stringify($cart), { expires: _expires, path: '/' });
    check();
  }

  return { check: check };

})(), // => END packingStatus

nothing = function() {},

calcCart = function(artikulId, incr, del) {
  var
    cart = ($.cookie('cart') === undefined) ? {} : JSON.parse($.cookie('cart')),
    _targetInput = $("#" + artikulId),
    _inCart = $("#in_cart_" + artikulId),
    _amount = parseInt(_targetInput.val()),
    _event = 'update',
    _delete = (del === undefined) ? false : del,
    _pack = _inCart.hasClass('_pack'),
    _k = parseInt(_targetInput.attr('step')),
    _data = _targetInput.data(),
    item = {
      id: _data.artikul,
      nid: _data.nomid,
      cat: _data.categoryid,
      pp: _data.porpack,
      ps: _data.porstep,
      sid: _data.shopid,
      p: _data.price,
      s: 1,
      t: _data.type,
      d: _data.delivery
    };

  if( !( (/\d/).test( _amount ) ) ){
    // если в поле ввода попал текст
    return _targetInput.val(0);
  }

  // while(cart.length > 1) { cart = JSON.parse(cart); };

  var startAmount = _amount;

  if ( incr ) {
    if (_amount === 0) {
      _event = 'add';
    }
    _amount = _amount + _k;
  } else {
    if ( _amount > 0 ) {
      _amount = _amount - _k;
      _event = ( _amount > 0 || _pack ) ? 'update' : 'delete';
      if(_delete) {
        _amount = 0;
        _event = 'delete';
      }
    } else {
      _amount = 0;
      _event = 'nothing';
    }
  }

  _targetInput.val(_amount);
  item['a'] = _amount;

  cart[_data.nomid] = item;
  if (_event==='delete') {
    delete cart[_data.nomid];
  }

  $total = calculateCart(cart);

  $.when( packingStatus.check() ).done(function(){
    $total = calculateCart(cart);
  });

  switch (_event) {
    case 'add':
      _log('add cartItem:', item);
      widgetCart.createItem(item);
      var itemCart = item;
      // analitycsService.addToCartGA(itemCart);
      dataLayer.push({ ecommerce: null });
      dataLayer.push(analitycsService.addToCart(itemCart));
      metrikaService.reachGoal(17270917, 'add_to_cart');
      _log('window.dataLayer', window.dataLayer);
      break;

    case 'update':
      _log('update cartItem:', item);
      widgetCart.updateItem(_inCart, item);
      metrikaService.reachGoal(17270917, 'update_cart');
      break;

    case 'delete':
      _log('delete cartItem:', item);
      widgetCart.deleteItem(_inCart);
      var itemCart = item;
      itemCart.a = startAmount;
      // analitycsService.removeFromCartGA(itemCart);
      dataLayer.push({ ecommerce: null });
      dataLayer.push(analitycsService.removeFromCart(itemCart));
      metrikaService.reachGoal(17270917, 'remove_from_cart');
      _log('window.dataLayer', window.dataLayer);
      break;

    default: nothing(); break;
  }

  $("#pbp_" + _data.artikul).html( parseInt( _data.price * _amount ) );

  if ($total.price <= 0) { widgetCart.hide(); }
  if ($total.amount === 1 && _event === 'add') { widgetCart.show($total); }

  return {
    event: _event,
    amount: _amount
  }

}, // => calcCart

calculateCart = function(cart) {
  var total_goods = 0,
    _expires = $nWD,
    total_spent = 0;

  $.cookie('cart', JSON.stringify(cart), { expires: _expires, path: '/' });

  if ( $('[data-categoryid="6"]').length > 0 ) {
    total_spent = 0 + $packing;
  } else {
    total_spent = 0;
  }

  $.each(cart, function(id, item){
    if ( item.a > 0 && item.s && item.cat != 6 ) {
      var itemId = $('#' + item.id),
        p = item.p,
        ps = 1,
        pp = 1;

      if ( itemId.length > 0 ) {
        p = parseInt( itemId.data('price') );
        ps = itemId.data('porstep');
        pp = itemId.data('porpack');
      }

      total_goods += 1;
      total_spent += parseInt( p * ( parseInt( item.a ) ) ); // общая стоимость корзины
    }
  });

  if( total_goods == 0){
    total_spent = 0;
    $.cookie('cart', null, { expires: -1, path: '/' });
  };

  $(".cart_total ._items").html('<span class="_total_amount">' + total_goods +'</span> <span>' + declination('товаров','товар','товара', total_goods) + '</span>');

  $total = {
    price: total_spent,
    amount: total_goods
  };
  return $total;
}, // => calculateCart

deliveryTmpl = function (delivery) {
  var deliveryText = '<strong>бесплатно</strong>';
  if ( delivery > 0 ) {
    deliveryText = '<strong>'+delivery+'<small>&nbsp;руб.</small></strong>';
  };
  return '<li id="delivery_item">'+
    '<span class="picture">&nbsp;</span>'+
    '<b>Доставка</b>'+
    '<b class="_mask">&nbsp;</b>'+
    '<em><span>&nbsp;</span></em>'+
    deliveryText+
    '</li>';
}, // => END deliveryTmpl

packingToggle = function (){
  var packingStatusCheck = packingStatus.check();
  if ( packingStatusCheck && $('#packing_item').length == 0 ) {
    $("#nomenclature_in_cart").append(pakinkgTmpl($packing));
  };

  if ( !packingStatusCheck && $('#packing_item').length > 0 ) {
    $('#packing_item').remove();
  };
}, // => END packingToggle

pakinkgTmpl = function (packing) {
  return '<li id="packing_item">'+
  '<span class="picture">&nbsp;</span>'+
  '<b>Упаковочный материал</b>'+
  '<b class="_mask">&nbsp;</b>'+
  '<em><span>1 Шт.</span></em>'+
  '<strong>'+packing+'<small>&nbsp;руб.</small></strong>'+
  '</li>';
}, // => END pakinkgTmpl

clearForm = function(form) {
  form.trigger("reset");
  form.find("input, textarea, label").removeClass("form__error").removeClass("form__success");
  form.find("select").select();
},

// Валидация форм
// $form - объект JQ с целевой формой
// $submitBtn - jq-объект кнопки отправки формы, если отличается от стандартной submit
// $disabled - true|false блокировать кнопку отправки после нажатия
validationForm = function($form, $submitBtn, $disabled) {
  var
    _pattern = {
      'email': /^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,6}$/gi,
      'tel': /^(8|\+7|7)\(?[0-9]{3}\)?[0-9]{3}-?[0-9]{2}-?[0-9]{2}$/gi
    },
    inputs = $form.find("input")
      .not("input[type='submit']")
      .not("input[type='reset']")
      .not("input[type='file']")
      .not("input[type='checkbox']")
      // .not("input[type='radio']")
      .not("input[type='hidden']"),
    formBtnSubmit = ($submitBtn)? $submitBtn : $form.find("[type='submit']"),
    textarea = $form.find("textarea"),
    allInputs = $.merge(inputs, textarea),
    isValid = true,
    _disabled = (!$disabled)? $disabled : true;

  $.each(allInputs, function (i, item) {
    // console.log(allInputs);
    var
      $input = $(item),
      $label = $input.parent().find('label'),
      val = $.trim($input.val().toLowerCase()),
      required = ( $input.hasClass("_required") || $input.hasClass("required") || $input.attr("required") ) ? true : false;

    // console.log($input.attr('name'), $input.val());
    $input.parent().find('.error').html('');

    if(_disabled && !checkMinOrder()){
      formBtnSubmit.prop("disabled", true);
    }

    if (!val && required ) {
      // Проверка на заполненность обязательных полей
      $input.addClass("form__error").removeClass("form__success");
      $label.addClass("form__error").removeClass("form__success");
      $input.parent().find('.error').html('<i class="fa fa-exclamation-circle" aria-hidden="true" title="Обязательное поле"></i>');
      isValid = false;
      // console.log($input.parent().find('label'))
    }
    else if ( val && !$input.val().match(_pattern[$input.attr("type")]) ) {
      $input.addClass("form__error").removeClass("form__success");
      $label.addClass("form__error").removeClass("form__success");
      isValid = false;
    }
    else {
      $input.parent().find('.error').html('');
      $input.addClass("form__success").removeClass("form__error");
      $label.removeClass("form__error").addClass("form__success");
    };

    if( $input.attr('type') === 'radio' && required ) {
      var
        $radios = $('[name="'+ $input.attr('name') +'"]'),
        _validRadio = false;
      $.each($radios, function (i, radio) {
        if($(radio).is(':checked')) {
          _validRadio = true;
        };
      });

      if(!_validRadio) {
        $radios.addClass("form__error").removeClass("form__success");
        isValid = false;
      } else {
        $radios.addClass("form__success").removeClass("form__error");
      }

    }

  });

  if(!isValid) {
    formBtnSubmit.parent().find('.invalid-feedback').show();
  }

  if(_disabled){
    formBtnSubmit.prop("disabled", !isValid);
  }

  return isValid;
},

// Быстрый заказ
quick_order = (function(){
  var
    $quickOrder = $('.quick_order'),
    $quickOrderInput = $quickOrder.find('input'),
    $quickOrderBtn = $quickOrder.find('._send');

  function init() {
    _setUpListners();
  }

  function _setUpListners() {
    $quickOrderBtn.on('click', _submit);
  }

  function _submit(event){
    $quickOrder = $(this).parents('.quick_order');

    var _validationForm = validationForm($quickOrder, $(this), false),
      $cart = ($.cookie('cart') === undefined) ? '' : $.cookie('cart');

    if (_validationForm && $cart.length > 0) {
      return $quickOrderBtn
        // .prop("disabled",true)
        // .attr("disabled", 'disabled')
        .addClass('disabled')
        .addClass('progress');
    } else {
      if ($cart.length === 0) {
        $quickOrder.parents('.product__controls__wrap').find('.product__controls').addClass('form__error');
      } else {
        $quickOrder.parents('.product__controls__wrap').find('.product__controls').removeClass('form__error');
      }
      event.preventDefault();
      return false;
    }
  }

  return {
    init: init
  };

})(), // => END quick_order

checkMinOrder = function() {
  if( parseInt($('#min_order').val) > 0 && parseInt($('#min_order').val) > parseInt($('#current_order').val) ) {
    return false;
  }
  return true;
},

clearOldCookie = function(){
  cookie.clear('currVer');
  cookie.clear('cart');
  cookie.clear('comment');
  cookie.clear('email');
  cookie.clear('fio');
  cookie.clear('phone');
  cookie.clear('street');
  cookie.clear('street_name');
  cookie.clear('street_numb');
  cookie.clear('street_room');
  cookie.clear('shop');
},

clearOldStorage = function() {
  storage.remove('selectShop');
  storage.remove('basket');
},

getRandomInt = function(min, max){
  return Math.floor(Math.random() * (max - min + 1)) + min;
},

checkRecall = function() {
  // Проверяем выбран ли параметр "Не перезванивать"
  if( $('#notRecall').is(':checked') ){
    $('input#time').prop("required", true);
  } else {
    $('input#time').prop("required", false);
  }
},

productPreview = function($product, _load) {
  var
    $parent = $product.parents('.section__menu-product'),
    $parentID = $parent.attr('id'),
    _src = $parent.find('.product__image-img').data('src'),
    _srcset = $parent.find('.product__image-img').data('srcset'),
    imgbig = $parent.find('.product__image-img').data('imgbig'),
    closeBtn = $('<span class="close-preview" />'),

    $bProductPreview = $('.section__menu-product.product__preview'),
    $bProductPreviewSrcset = $bProductPreview.find('.product__image-img').data('srcset'),
    $bProductPreviewSrc = $bProductPreview.find('.product__image-img').data('src'),

    _k = orderElmK,
    _index = $parent.index() + 1,
    _step = parseInt($parent.index()/_k) * _k,
    _shift = _step + (_k + 1);

  if( $product.hasClass('__noclick') ){ return false; }

  if( !_load ){
    $bProductPreview
      .css({ 'order': $bProductPreview.attr('data-index') })
      .removeClass('product__preview');
  }

  $parent
    .addClass('product__preview')
    .css({ 'order': _step })
    .append(closeBtn);

  $.when( scrollCatalog('#'+$parentID, 300, null) ).done(function(){
    $bProductPreview
    .find('.product__image-img')
    .attr('srcset', $bProductPreviewSrcset)
    .attr('src', $bProductPreviewSrc);
    if( !_load ){
      document.location.hash = $parentID;
    }
  });

  $parent.find(closeBtn).on('click',function(){
    $parent
      .css({ 'order': $parent.attr('data-index') })
      .removeClass('product__preview');
    $parent
      .find('.product__image-img')
      .attr('srcset', _srcset)
      .attr('src', _src);
    $(this).remove();
  });

  if ( typeof(imgbig)!= 'undefined' && imgbig ) {
    $parent
      .find('.product__image-img')
      .attr('srcset','')
      .attr('src', imgbig);
  }
};

// ### PRELOAD
window.addEventListener('DOMContentLoaded', function () {

  var
  sFadeStartColor = "#ededed",
  sFadeFinishColor = "#FF4500",
  aRGBStart = sFadeStartColor.replace("#","").match(/.{2}/g),
  aRGBFinish = sFadeFinishColor.replace("#","").match(/.{2}/g),
  options = {
    "backgroundColor": sFadeStartColor,
    "barColor": "#cccccc",
    "percentage": true,
    "maxTime": 5000,
    "fadeOutTime" : 0,
    "barHeight": 1,
    "onProgress": function(e) {
      if(document.getElementsByClassName('queryloader__overlay__bar').length > 0) {
        document.getElementsByClassName('queryloader__overlay__bar')[0].style.backgroundColor = _getFadeMiddleColor(Math.floor(e));
      }

      // $('.nested-container img').each(function(){
      //   var self = $(this);
      //   // self.css({'width':'auto','max-width':'none'});
      //   self.removeClass('img-responsive').css({ 'width':'auto' });
      // })
    },
    "onComplete": function(e) {
      // window.scrollTo(0,0);
      if (document.getElementById("over") !== null) {
        document.body.removeChild(document.getElementById("over"));
      }
      if (document.getElementById("qLtempOverlay") !== null) {
        document.body.removeChild(document.getElementById("qLtempOverlay"));
      }
      // document.body.removeChild(document.getElementById("qLtempOverlay"));
      $('body > .wrapper').fadeIn(100);

      if ( $('.row-1').length >0 && $('.row-1').length >=2 ) {
        $('.row-1').each(function(){
          var self = $(this);
          if ( self.find('img').height() > 87 ) {
            self.removeClass('row-1');
          }
          else {
            var dataCol = self.data('col');
            if ( self.parents('.content').find('.row-wrap').length ==0 ) {
              self.before('<div class="row-wrap col-sm-'+dataCol+' col-xs-'+((dataCol<=6)?dataCol*2:'12')+'"></div>');
            };
            $('.row-wrap').each(function(){
              var wrap = $(this);
              if ( wrap.find('row-wrap_item').length <=2 ) {
                wrap.append(self);
                self.attr('class','row-wrap_item col-xs-12').css({'padding-left':0,'padding-right':0});
              };
            });
          };
        });
      };

      // ### SVG helper
      svg4everybody();

      // ### Slick Carousel
      if ( $('.carousel-main').length > 0 ) {
        var
          _autoplay = $('#carouselMain').data('autoplay'),
          _carousel = $('.carousel-main');

        _carousel.slick({
          autoplay: _autoplay,
          autoplaySpeed: 10000,
          arrows: true,
          dots: false,
          infinite: true,
          speed: 500,
          fade: true,
          centerMode: true,
          variableWidth: false,
          cssEase: 'linear',
          responsive: [
            {
              breakpoint: 1025,
              settings: {
                autoplay: _autoplay,
                arrows: true
              }
            },
            {
              breakpoint: 721,
              settings: {
                autoplay: _autoplay,
                arrows: false
              }
            },
            {
              breakpoint: 321,
              settings: {
                autoplay: _autoplay,
                arrows: false
              }
            }
          ]
        });
      }

      // ### Cashback Card
      if (document.location.pathname == '/cashback') {
        $('.cashback__card').hide();
      } else {
        $.affix({
          wrap: false,
          target: '.cashback__card',
          offset: $('main').offset().top - 150,
        });
      }

      // ### Header Background
      if($('.header').length > 0) {
        $.affix({
          target: '.header',
        });
      }

      // ### NavBar Background
      if($('.navbar').length > 0) {
        $.affix({
          target: '.navbar',
          offset: $('.header').offset().top,
        });
      }

      // ### Cart Background
      $.affix({
        target: '.cart_wrap',
      });

      // ### Affix Background
      $.affix({
        wrap: false,
        target: '.affix-bg',
        offset: $('main').offset().top - ( $('.header').outerHeight(true) + $('.navbar').outerHeight(true) )
      });

      // ### nav-menu
      if($('.nav-menu').length > 0) {
        $.affix({
          target: '.nav-menu',
          offset: $('main').offset().top - ( $('.header').outerHeight(true) + $('.navbar').outerHeight(true) ),
        });
      }

      // $(window).on('scroll', function(){
      //   _scrollSpyOffset = parseInt($('.header').innerHeight() + $('.navbar').innerHeight() + $('.nav-menu').innerHeight());
      //   console.log('window/scroll/_scrollSpyOffset', _scrollSpyOffset);
      // });

      $('.navbar-nav .nav-link, .navbar-nav .dropdown-item')
        .not('.dropdown-toggle')
        // .on('click touchstart', function (e){
        .on('click', function (e){
          var self = $(this),
            href = (self.attr('href')).split('#')[1],
            id = '#' + href;

          $('.navbar-collapse').collapse('hide');
          $('.dropdown-menu').dropdown('hide');

          if ( $(id).length > 0 ) {
            e.preventDefault();

            // Скролл к цели и закрыть навигацию
            $.when( scrollCatalog(id) ).done(function(){
              document.location.hash = href;
              // document.location.hash = '#';
            });

            return false;
          } else {
            return document.location.href = self.attr('href');
          };
        });

      // $("img.lazyload").lazyload();

      // Костыль для картинок в заголовках категорий меню

      function imgCategoryTitle(_id, _src, _alt = null, _style = null) {
        var imgCategoryTmplt = $('<img class="img-fluid section__menu-title-img" />');
        if($('#' + _id).length > 0) {
          $('#' + _id)
            .find('.section__menu-title')
            .html(imgCategoryTmplt
              .attr('style', _style)
              .attr('alt', _alt)
              .attr('src', _src));
        }
      }

      var imgCategoryTitleArr = [
        {
          'id': 'sets',
          'src': '/assets/front/img/menu/category_title/sets.png',
          'alt': 'Сеты',
        },
        {
          'id': 'rolls-lux',
          'src': '/assets/front/img/menu/category_title/rolls_lux.png',
          'alt': 'Роллы Люкс',
        },
        {
          'id': 'rolls',
          'src': '/assets/front/img/menu/category_title/rolls.png',
          'alt': 'Роллы',
        },
        {
          'id': 'sushi-box',
          'src': '/assets/front/img/menu/category_title/sushibox.png',
          'alt': 'Суши-бокс',
        },
        {
          'id': 'onigiri',
          'src': '/assets/front/img/menu/category_title/onigiri.png',
          'alt': 'Онигири',
        },
        {
          'id': 'tempura-rolls',
          'src': '/assets/front/img/menu/category_title/tempura.png',
          'alt': 'Темпура',
        },
        {
          'id': 'tom-yam',
          'src': '/assets/front/img/menu/category_title/tom_yam.png',
          'alt': 'Том Ям',
        },
        {
          'id': 'wok',
          'src': '/assets/front/img/menu/category_title/wok.png',
          'alt': 'Воки',
        },
        {
          'id': 'drinks',
          'src': '/assets/front/img/menu/category_title/drinks.png',
          'alt': 'Напитки',
        },
        {
          'id': 'extras',
          'src': '/assets/front/img/menu/category_title/extras.png',
          'alt': 'Дополнительно',
        },
      ];

      for (let index = 0; index < imgCategoryTitleArr.length; index++) {
        const imgCategoryTitleItem = imgCategoryTitleArr[index];
        imgCategoryTitle(
          imgCategoryTitleItem.id,
          imgCategoryTitleItem.src,
          imgCategoryTitleItem.alt,
          imgCategoryTitleItem.style
        );
      }

      // ### Snow in header
      if ($('.newyear').length > 0) {
        if($.snow !== undefined) {
          $.snow({
            // flakeChar: '<i class="fa fa-snowflake-o"></i>',
            // flakeChar: '❅',
            // flakeList: ['❅', '❄', '❆', '❇', '❈', '❋', '❊', '❉', '❃'],
            minSize: 10,
            maxSize: 28,
            newOn: 250,
            flakeColor: ["#ffffff"],
            target: ".header",
            positionTop: '-15px',
            zIndex: 1
          });
        }
      }

      $(function() {
        var
          _scrollSpyTarget = '#nav-menu',
          _headerInnerHeight = $('.header').innerHeight(),
          _navbarInnerHeight = $('.navbar').innerHeight(),
          _scrollSpyOffset = parseInt(_headerInnerHeight + _navbarInnerHeight + $(_scrollSpyTarget).innerHeight());
        console.log('_scrollSpyOffset', _scrollSpyOffset);

        $('body').scrollspy({
          spy: "scroll",
          target: _scrollSpyTarget,
          offset: _scrollSpyOffset
        });

        // Ставим специально до запуска скролла по хэшу
        scrollSubNav();

        // ### Навигация по якорям // Скролл по хэшу в урле при загрузке
        var hashData = document.location.hash;
        // if ( hashData ) { scroll(0,0); }

        if ( $(hashData).length > 0 ) {
          document.location.hash = '#';
          // scrollCatalog(hashData);
          $.when( scrollCatalog(hashData, 100, 'direct') ).done(function(){
            document.location.hash = hashData;
          });
        }

        if($('[data-toggle="popover"]').length > 0) {
          $('[data-toggle="popover"]').popover();
        }

        if($('[data-toggle="tooltip"]').length > 0) {
          $('[data-toggle="tooltip"]').tooltip();
        }

        if(!$.cookie('cookieAgree')) {
          var $cookieAgree = $('<div id="cookieAgree" style="display:none;"><button type="button" class="close" title="Соглашаюсь"><i class="fa fa-times" aria-hidden="true"></i></button><span>Мы используем cookie для быстрой и удобной работы сайта. Используя наш сайт, вы принимаете <a target="_blank" class="text-primary" href="/privacy-policy/" rel="nofollow">условия обработки персональных данных</a>.</div>');
          $('body').append($cookieAgree);
          $('#cookieAgree').show('slow');
          $('#cookieAgree').on('click', '.close', () => {
            $('#cookieAgree').hide('slow');
            $.cookie('cookieAgree', 1);
          });
        }
      });

    }

  };

  // Вычисляет промежуточные цвета
  function _getFadeMiddleColor(i) {
    var n = 100,  // колличество промежуточных цветов
      finishPercent = i/n,
      startPercent = 1 - finishPercent,
      R,G,B;

    R = Math.floor( ('0x'+aRGBStart[0]) * startPercent + ('0x'+aRGBFinish[0]) * finishPercent );
    G = Math.floor( ('0x'+aRGBStart[1]) * startPercent + ('0x'+aRGBFinish[1]) * finishPercent );
    B = Math.floor( ('0x'+aRGBStart[2]) * startPercent + ('0x'+aRGBFinish[2]) * finishPercent );

    return 'rgb('+R+ ',' + G + ',' + B +')';
  }

  $("body").queryLoader2(options);

});
///* /Preload */

/* ### INIT ### */
// $(document).ready(function($) {
$(function() {

  $('noscript').remove();

  $('.debug').html('В случае возникновения ошибки, перейдите по <a class="text-primary" href="/?clear" rel="nofollow">этой ссылке</a>');

  if(!window.isSafari){
    $('.modal').attr('data-backdrop', true);
  }

  if($('#modalQuarantine').length > 0) {
    $('#modalQuarantine').modal('show');
  }

  // var _scrollSpyOffset = parseInt($('.header').innerHeight() + $('.navbar').innerHeight() + $('.nav-menu').innerHeight());
  // console.log('init/_scrollSpyOffset', _scrollSpyOffset);

  // $('body').scrollspy({
  //   target: $('body').attr('data-target'),
  //   offset: _scrollSpyOffset
  // });

  // $(window).on('scroll', function(){
  //   _scrollSpyOffset = parseInt($('.header').innerHeight() + $('.navbar').innerHeight() + $('.nav-menu').innerHeight());
  //   console.log('window/scroll/_scrollSpyOffset', _scrollSpyOffset);
  // });

  if ( $select_shop ) {
    $('.points-icon-list').find('[data-shopid="'+$select_shop+'"]').addClass('selected');
  }

  if ( window.devicePixelRatio > 1 ) {
    $('.product__image-img').each(function(){
      $(this).attr('src', $(this).attr('data-origin') );
    });
  }

  // Работа с карточкой товара
  var
  recalcStep = function (){
    orderElmK = 4;
    if ( window.innerWidth <= desktopScreen - 1 ) {
      orderElmK = 3;
      if ( window.innerWidth <= notebookScreen - 1 ) {
        orderElmK = 2;
        if ( window.innerWidth <= tabletScreen - 1 ) {
          orderElmK = 1;
        }
      }
    }
  },

  recalcFlexOrder = function(){
    $('.section__menu').each(function(){
      var $section = $(this);
      $section.find('.section__menu-product').each(function(){
        var
          _k = orderElmK,
          _index = $(this).index() + 1,
          _step = parseInt($(this).index()/_k) * _k,
          _shift = _step + (_k + 1);
        $(this)
          .attr( 'data-shift', _index + ':' + _step + ':' + _shift )
          .attr( 'data-index', _index)
          .css({ 'order': _index });
      });
    });
  };

  recalcStep();
  recalcFlexOrder();

  $(window).on('resize orientationchange',function(){
    recalcStep();
    recalcFlexOrder();

    if ( window.innerWidth < tabletScreen ) {
      $('.section__menu-product').toggleClass('__noclick');
    }

    if ( window.innerWidth > mobileScreen ) {
      $('.header__preorder-wrap')
        .attr('href', 'javascript:void(0)')
        .on('click', function(){
          return false;
        });
    }
  });

  if ( window.innerWidth > mobileScreen ) {
    $('.header__preorder-wrap')
      .attr('href', 'javascript:void(0)')
      .on('click', function(){
        return false;
      });
  }

  if ( window.innerWidth < tabletScreen ) {
    $('.section__menu-product').toggleClass('__noclick');

    $('.section__menu-product .product__image-img').each(function(){
      var categoryid = $(this).parents('.product').find('.product__name').data('categoryid'),
        caption = $(this).parents('.product').find('.product__name').text(),
        href = $(this).data('imgbig'),
        thumb = $(this).attr('data-src');
      $(this).wrap('<a href="'+href+'" data-fancybox="'+categoryid+'" data-caption="'+caption+'" data-thumb="'+thumb+'"></a>');
    });

    $("[data-fancybox]").fancybox({
      fitToView: true,
      autoSize: true,
      // width: '100%',
      margin: 0,
      padding: 0,
      closeBtn: true,
      nextEffect: 'none',
      prevEffect: 'none',
      fullScreen: {
        autoStart: false,
      },
      buttons: [
        // 'slideShow',
        // 'fullScreen',
        'thumbs',
        // 'share',
        // 'download',
        // 'zoom',
        'close'
      ],
      slideShow: {
        autoStart: false,
        speed: 4000
      },
      thumbs: {
        autoStart: false, // Display thumbnails on opening
        hideOnClose: true, // Hide thumbnail grid when closing animation starts
        parentEl: '.fancybox-container', // Container is injected into this element
        axis: 'y' // Vertical (y) or horizontal (x) scrolling
      },
      afterShow: function() {
        $(this).on('touchstart');
        $(window).on('orientationchange', function() {
          $.fancybox.update()
        });
      },
      afterClose: function(){
      }
    });
  }

  $('.section__menu-product')
    .not('a')
    .not('.__noclick')
    .on('click', '.product__image,.product__name,.product__description', function(){

      if(!$(this).parents('.section__menu-product').hasClass('product__preview')) {
        productPreview($(this), false);
      }

      $('.section__menu-product.product__preview a').on('click', function(){
        return false;
      });
      return false;
    });

  if ( $('.section__menu-product').length > 0 ) {
    if( $(document.location.hash).hasClass('section__menu-product') ){
      productPreview($(document.location.hash + ' .product__name'), true);
    }
  }

  $('#accordionPayment').find('input[type="radio"]').prop('checked', false);

  if ( $('#min_order_value').length > 0 ) {
    $('#min_order_value').val(min_order_value);
  };

  var cart = cookie.getCart();
  if (isEmpty(cart)) {
    $.cookie('cart', null, { expires: -1, path: '/' });
  }

  widgetCart.init();

  $(document).on('click', '.calc', function(e){
    var self = $(this),
      _artikulId = parseInt(self.data('artikul')),
      _incr = (self.hasClass('_plus'))? true: false;
    if (self.hasClass('delete')) {
      calcCart(_artikulId, false, true);
    } else {
      calcCart(_artikulId, _incr);
    }
    return false;
  });

  // Быстрый заказ
  if( $('.quick_order').length > 0 ) { quick_order.init(); }

  // Скрыть пустые категории в меню
  if ( $('.section__menu-row').length > 0 ) {
    $('.section__menu-row').each(function(){
      var self = $(this);
      if ( self.find('.product').length == 0 ){
        $('.navbar [data-id="'+ self.parents('.section__menu').attr('id') +'"]').hide();
        self.parents('.section__menu').hide();
      }
    });
  }

  if ( $('.inputmask').length > 0) {
    $(".inputmask.input-phone").inputmask("+7(999)999-99-99");
    $(".inputmask.input-time").attr('pattern','[0-2][0-9]:[0-5][0-9]').inputmask("99:99");
  }

  // Бегушка
  if ( $('.marquee').length > 0 ) {
    $('.marquee').marquee({
      duration: 8000,
      gap: 18,
      delayBeforeStart:0,
      duplicated: true
    });
  };

  var currVerCookie = ($.cookie('currVer') === undefined) ? 0 : JSON.parse($.cookie('currVer'));
  if ( currVerCookie ){
    if ( currVerCookie != $currVer ) {
      clearOldCookie();
      clearOldStorage();
    };

  } else {
    clearOldCookie();
    clearOldStorage();
    var _expires = $nWD;
    $.cookie('currVer', $currVer, { expires: _expires, path: '/' });
  };

  $('.navbar .nav-link').on('click touchstart', function (e){
    var self = $(this),
      href = (self.attr('href')).split('#')[1],
      id = '#' + href;

    if(self.hasClass('active')) { return false; }

    if ( $(id).length > 0 ) {
      e.preventDefault();

      // Скролл к цели и закрыть навигацию
      $.when( scrollCatalog(id, 300, null) ).done(function(){
        document.location.hash = href;
        // document.location.hash = '#';
      });

      return false;
    } else {
      return true;
    };

  });

  $('.nav-menu .nav-link')
  .on('click', function (e){
    var self = $(this),
      href = (self.attr('href')).split('#')[1],
      id = '#' + href;

    if(self.hasClass('active')) { return false; }

    if ( $(id).length > 0 ) {
      e.preventDefault();

      // Скролл к цели и закрыть навигацию
      $.when( scrollCatalog(id, 300, null) ).done(function(){
        document.location.hash = href;
        // document.location.hash = '#';
      });

      return false;
    } else {
      return true;
    };

  });

  if ($(".recall").length) { recall.init(); }

  checkRecall();

  $('#notRecall').on('change', function() {
    checkRecall();
  });

  var workTimeStart = '9:30',
    workTimeEnd = '22:00';

  if ( $('.timepicker').data('start') != '' ) {
    workTimeStart = $('.timepicker').data('start');
    workTimeEnd = $('.timepicker').data('end');
  }

  $('.timepicker').timepicker({
    timeFormat: 'HH:mm',
    interval: 30,
    // minTime: currHours+':'+currMinutes,
    minTime: workTimeStart,
    maxTime: workTimeEnd,
    startTime: (currHours+1) +':00',
    dynamic: false,
    dropdown: true,
    scrollbar: true
  });

  $('.selectize').selectize({ create: true, });

  if(document.location.hash == '#web_app_manifest'){
    $.cookie('sb-closed','true');
    $('.header-item_logo__link, .nav-main__logo-link').attr('href','/#web_app_manifest');
    $smartbanner = false;
  }

  // if($smartbanner){
  //   $.smartbanner({
  //     title: 'Приложение Экспресс суши', // What the title of the app should be in the banner (defaults to <title>)
  //     author: false, // What the author of the app should be in the banner (defaults to <meta name="author"> or hostname)
  //     price: 'Бесплатно', // Price of the app
  //     appStoreLanguage: 'ru', // Language code for App Store
  //     inAppStore: 'в App Store', // Text of price for iOS
  //     inGooglePlay: 'в Google Play', // Text of price for Android
  //     inAmazonAppStore: false,
  //     inWindowsStore: false, // Text of price for Windows
  //     GooglePlayParams: false, // Aditional parameters for the market
  //     // icon: null, // The URL of the icon (defaults to <meta name="apple-touch-icon">)
  //     // iconGloss: null, // Force gloss effect for iOS even for precomposed
  //     url: null, // The URL for the button. Keep null if you want the button to link to the app store.
  //     button: 'Загрузить', // Text for the install button
  //     scale: 'auto', // Scale based on viewport size (set to 1 to disable)
  //     speedIn: 300, // Show animation speed of the banner
  //     speedOut: 400, // Close animation speed of the banner
  //     daysHidden: 3, // Duration to hide the banner after being closed (0 = always show banner)
  //     daysReminder: 90, // Duration to hide the banner after "VIEW" is clicked *separate from when the close button is clicked* (0 = always show banner)
  //     force: null, // Choose 'ios', 'android' or 'windows'. Don't do a browser check, just always show this banner
  //     hideOnInstall: true, // Hide the banner after "VIEW" is clicked.
  //     layer: false, // Display as overlay layer or slide down the page
  //     iOSUniversalApp: true, // If the iOS App is a universal app for both iPad and iPhone, display Smart Banner to iPad users, too.
  //     appendToSelector: 'body', //Append the banner to a specific selector
  //     onInstall: function() {
  //       // alert('Click install');
  //     },
  //     onClose: function() {
  //       // alert('Click close');
  //     }
  //   });
  // }

  if ($(".popup").length > 0) {
    // $('.delivery-zone').after('<div style="display:none;" id="popupMapDelivery" class="w-50"><script type="text/javascript" charset="utf-8" async src="https://api-maps.yandex.ru/services/constructor/1.0/js/?sid=6Ynl97IPiICHL-fAJKypbcXkSq2fer4m&width=100%&height=720&amp;lang=ru_RU&sourceType=constructor&scroll=true&id=popupMapDelivery"></script></div>');

    // $('.delivery-zone').after('<div style="display:none;" id="popupMapDelivery">'+
    // 	'<div style="position:relative;overflow:hidden;">'+
    // 		'<a href="https://yandex.ru/maps/66/omsk/?utm_medium=mapframe&utm_source=maps" style="color:#eee;font-size:12px;position:absolute;top:0px;">Омск</a>'+
    // 		'<a href="https://yandex.ru/maps/66/omsk/?ll=73.338476%2C54.984539&mode=usermaps&source=constructorLink&um=constructor%3A8405ca148480a492524aa37fef64fc8620f7a6dbc84d956070515a2eaa70efed&utm_medium=mapframe&utm_source=maps&z=12.09" style="color:#eee;font-size:12px;position:absolute;top:14px;">Карта Омска с улицами и номерами домов онлайн — Яндекс.Карты</a>'+
    // 		'<iframe src="https://yandex.ru/map-widget/v1/-/CSWTQW41" width="100%" height="600" frameborder="0" allowfullscreen="true" style="position:relative;"></iframe>'+
    // 	'</div>'+
    // '</div>');

    $('.delivery-zone').after('<div style="display:none;" id="popupMapDelivery">'+
      // '<div style="position:relative;overflow:hidden;">'+
      // 	'<iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3Af91cca9b74c346717ec7a2837f837d138b6e8a90d41d136295121f1f1146be18&amp;source=constructor" width="100%" height="600" frameborder="0"></iframe>'+
      // '</div>'+
      // '<div class="input-group mb-3 check-delivery-address">'+
      // 	'<input type="text" class="form-control _input" placeholder="Проверьте, входит ли ваш адрес в зону доставки" aria-label="Проверьте, входит ли ваш адрес в зону доставки" aria-describedby="button-addon2" value="">'+
      // 	'<div class="input-group-append">'+
      // 		'<button class="btn btn-primary _check" type="button" id="button-addon2">Проверить</button>'+
      // 	'</div>'+
      // '</div>'+
      '<div id="deliveryZone" data-height="600" data-zoom="11"></div>'+
    '</div>');

    $(".popup").fancybox({
      // fitToView: false,
      fitToView: true,
      // autoSize: false,
      autoSize: true,

      maxWidth: 780,
      maxHeight: 780,
      width: '80%',
      height: '85%',
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none'
    });
  };

  if($('[name="obtaining_method"]').length > 0) {
    $('[name="obtaining_method"]').on('change', function(){
      var
        _this = $(this),
        _idTarget = _this.parents('[data-toggle="collapse"]').attr('data-target');
      $('[name="obtaining_method"]')
        .parents('.media')
        .find('.media-collapse input._required')
        .each(function(){
          var _self = $(this);
          _self.prop('required', false);
        });
      $(_idTarget)
        .find('input._required')
          .prop('required', $(this).is(':checked'));
      // console.log(_idTarget);
      if(_idTarget == '#collapseTakeaway') {
        $('#timeReceiveOrder').removeClass('d-none');
        $('#timeReceiveOrder').find('.required').prop('required', true);
      } else {
        $('#timeReceiveOrder').addClass('d-none');
        $('#timeReceiveOrder').find('.required').prop('required', false);
      }
      if(_idTarget == '#collapseDelivery') {
        $('#deliveryInfo').removeClass('d-none');
      } else {
        $('#deliveryInfo').addClass('d-none');
      }

      if($('[name="obtaining_method"][value="2"]').is(':checked')) {
        checkDelivery();
        $('#inputStreet[name="street"]').on('change',function(){
          checkDelivery();
        });
      }
    });
  }

  if($('[name="payment_method"]').length > 0) {
    var
      _btnSendOrder = $('#send_order'),
      _btnPay = $('<button id="pay_order" class="btn btn-md btn-primary" type="button" name="pay_order">Оплатить</button>');
    _btnPay.hide();
    _btnSendOrder.after(_btnPay);
    $('[name="payment_method"]').on('change', function(){
      // if($('[name="payment_method"][value="2"]').is(':checked') && $('[name="isTest"][value="1"]').is(':checked')) {
      if($('[name="payment_method"][value="2"]').is(':checked')) {
        _btnSendOrder.hide();
        _btnPay.show();

        _btnPay.on('click', function(e) {
          e.preventDefault();
          var _form = $('#order_form'),
            _formSer = _form.serialize();

          return $.post('/order/make', _formSer, "json")
            .done(function(data) {
              // console.log('make_order', data);
              if(data.success) {
                var _formRobokassa = $('<form style="display:none;" action="https://auth.robokassa.ru/Merchant/Index.aspx" method="POST"></form>');
                var _paymentData = data.callback.onlinePayment.iframe;
                for (var key in _paymentData) {
                  if (Object.hasOwnProperty.call(_paymentData, key)) {
                    var element = _paymentData[key];
                    _formRobokassa.prepend('<input type="hidden" name="'+ key +'" value="'+ element +'" />');
                  }
                }
                _formRobokassa.append($('<input type="submit" value="Оплатить">'));
                $('body').append(_formRobokassa);
                _formRobokassa.trigger('submit');
              } else {
                console.error('Ошибка при обработке заказа', data);
              }
            })
            .fail(function(data) {
              console.error('Ошибка при обработке заказа', data);
            });
        });
      } else {
        _btnSendOrder.show();
        _btnPay.hide();
      }
    });
  }

  function checkDelivery() {
    if($.trim($('#inputStreet[name="street"]').val().toLowerCase()) !== '0') {
      return $.when( deliveryZone.check() ).then(function(response){
        var _dz = $.trim($('[name="dz"]').val().toLowerCase());
        // console.log('_dz', _dz);
        return false;
      }, function(error){
        console.error('Failed!', error);
        return false;
      });
    } else {
      return true;
    }
  }

  if($('#obtaining .collapse').length > 0) {
    $('#obtaining .collapse').collapse({
      toggle: false
    });
  }

  if($('[data-confirm]').length > 0) {
    $('[data-confirm]')
      .on('click', function(event){
        event.preventDefault();
        return callConfirm($(this));
      });
  }

  if($('[data-method]').length > 0) {
    $('[data-method]')
      .not('[data-confirm]')
      .on('click', function(event){
        event.preventDefault();
        return callMethod($(this));
      });
  }

  if($('.prepositions').length > 0) {
    $('.prepositions').each(function() {
      var _self = $(this);
      var str = _self.html();
      str = (str).replace(/(\s)([а-я+]{1,3})(\s)/gu, '$1$2&nbsp;');
      _self.html(str);
    });
  }

});